<template>
  <div class="home__medium" v-if="mediumFeedData">
    <div class="intro">
      <div class="intro__caption__holder">
        <!-- <div class="intro__index" data-gsap="fromStartEnd">05</div> -->
        <div class="intro__caption" >
          Articles & Insights
        </div>
      </div>

      <h2>Recent Blog Posts</h2>

      <a class="general-button transparent-white-background" href="https://medium.com/digital-done-properly" target="_blank">
        <span><external-icon/></span>
        Read all on Medium
      </a>
    </div>

    <div class="grid three">
      <a class="medium-post grid two" :href="post.link" v-for="(post, index) in mediumFeedData.items.slice(0, 3)" :key="index" target="_blank">
        <span><external-icon/></span>
        <p>{{ post.title }}</p> 
      </a>
    </div>
  </div>
</template>


<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import axios from 'axios';


import ExternalIcon from "../svg/ExternalIcon.vue"
// Define the type for the Post object
interface Post {
  link: string;
  title: string;
  content: string;
}

export default defineComponent({
    setup() {
      const mediumFeedData = ref<{ items: Post[] } | null>(null);

        async function fetchMediumFeed() {
            const response = await axios.get('https://api.rss2json.com/v1/api.json', {
                params: {
                    rss_url: 'https://medium.com/feed/@rain-digital',
                },
            });
            if (response.status === 200) {
                // Process the fetched Medium feed data
                mediumFeedData.value = response.data;
            }
        }

        onMounted(() => {
            fetchMediumFeed();
        });

        return {
            mediumFeedData,
        };
    },

    components: {
          'external-icon': ExternalIcon,
    },
    methods: {
        // getPostImage(content: string): string {
        //   const doc = new DOMParser().parseFromString(content, 'text/html');
        //   const imgTags = doc.querySelectorAll('img');

        //   for (let i = 0; i < imgTags.length; i++) {
        //     const imgTag = imgTags[i];

        //     const figCaptionTag = imgTag.nextElementSibling;

        //     if (figCaptionTag && figCaptionTag.tagName === 'FIGCAPTION') {
        //       const captionText = figCaptionTag.textContent || '';

        //       if (captionText.includes('By')) {
        //         // Skip to next image and look for the one after that
        //         continue;
        //       }
        //     }

        //     return imgTag.outerHTML; // Return the first image found
        //   }

        //   // If no image was found, return an empty string
        //   return '';
        // },
      },
});
</script>
